import React, { useEffect, useState } from "react";
import FormContainer from "../components/FormContainer";
import Map from "../components/Map";
import PatientRegister from "../components/PatientRegister";
import PatientList from "../components/PatientList";
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { getClinicDetails } from "../actions/clinicActions";
import Skeleton from "react-loading-skeleton";
import Loader from "../components/Loader";
import Message from "../components/Message";
import { Button } from "react-bootstrap";
import Help from "../components/Help";
import { FaHome } from "react-icons/fa";

const PatientListScreen = () => {
  const params = useParams();
  const clinicOwnerId = params.clinicOwnerId;

  const [searchParams, setSearchParams] = useSearchParams();
  const [clinicId, setClinicId] = useState(searchParams.get("clinicId"));
  const [reqDate, setReqDate] = useState(searchParams.get("reqDate"));

  const [pageNumber, setPageNumber] = useState(1);
  const [patientListVehicle, setPatientListVehicle] = useState([]);

  const userLogin = useSelector((state) => state.userLogin);
  const { userInfo } = userLogin;

  const clinicDetails = useSelector((state) => state.clinicDetails);
  const { norequest, loading, clinic, error } = clinicDetails;

  const patientListStore = useSelector((state) => state.patientListStore);
  const { pages, page } = patientListStore;

  const nextPageNumber = () => {
    setPageNumber(pageNumber + 1);
  };

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!userInfo) {
      navigate(
        `/login-screen?returnFrom=${location.pathname}&clinicId=${clinicId}`,
      );
    } else {
      if (norequest || !clinic || clinic._id !== clinicId) {
        if (!error) {
          dispatch(getClinicDetails(clinicId));
        }
      }
    }
  }, [clinicId, norequest, clinic]);
  return (
    <FormContainer>
      {loading && (
        <>
          <Skeleton height="50px" className="mb-5" />
        </>
      )}{" "}
      {error && (
        <Message
          children={`Get Clinic Details Err:${error}`}
          variant={`danger`}
        />
      )}
      {clinic && (
        <Map
          titles={[
            {
              idx: "1",
              label: (
                <>
                  <FaHome /> Home
                </>
              ),
              path: `/`,
              active: false,
            },
            {
              idx: "2",
              label: `Clinic List Screen`,
              path: `/clinic-list-screen`,
              active: false,
            },
            {
              idx: "3",
              label: `${clinic.clinicName}`,
              path: `/clinic-screen/${clinic._id}`,
              active: false,
            },
            {
              idx: "4",
              label: `Patients`,
              path: ``,
              active: true,
            },
          ]}
        />
      )}
      {loading ? (
        <Loader />
      ) : (
        <PatientRegister
          clinicOwnerId={clinicOwnerId}
          clinicId={clinicId}
          pageNumber={pageNumber}
          patientListVehicle={patientListVehicle}
          setPatientListVehicle={setPatientListVehicle}
        />
      )}
      <div className="mt-3">
        <PatientList clinicId={clinicId} reqDate={reqDate && reqDate} />
      </div>
      {!loading && patientListVehicle && (
        <>
          {pages - page * 10 > 0 && (
            <Button className="btn btn-block" onClick={nextPageNumber}>
              Load More
            </Button>
          )}
        </>
      )}
      <Help />
    </FormContainer>
  );
};

export default PatientListScreen;
